import styled from 'styled-components';

import { CFG } from '../../../../../../theme/configurator-tokens';
import { Text } from '../../../../../../components';

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0 8px;
`;

export const Heading = styled(Text)`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.1;
  color: ${CFG.base50};
`;

/* --- Country tag row -------------------------------------------------------- */
export const CountryRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  font-size: 14px;
  line-height: 1.2;
`;

export const CountryLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const CountryLabel = styled(Text)`
  font-weight: 300;
  color: ${CFG.base500};
`;

export const CountryName = styled.span`
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${CFG.base50};
`;

export const Flag = styled.img`
  height: 12px;
  width: auto;
  max-width: 18px;
  border-radius: 2px;
  object-fit: contain;
`;

export const ChangeCountry = styled.button`
  cursor: pointer;
  border: 0;
  background: transparent;
  padding: 0;
  color: ${CFG.brandAlt};
`;

/* --- Theme list ------------------------------------------------------------- */
export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BrowseRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 8px;
`;
